import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "mobx-react";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { init } from "./stores";
import "./index.scss";
import { register } from "./registerServiceWorker";
import { listenForBeforeInstallPrompt } from "./installEventListener";

/*eslint no-underscore-dangle: ["error", { "allow": ["_babelPolyfill"] }]*/
/* eslint-disable global-require */
if (!window._babelPolyfill) {
  require("babel-polyfill");
}

/* eslint-enable global-require */
let timer = 0;
const firstTime = localStorage.getItem("first_time");
if (!firstTime) {
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    )
  ) {
    timer = process.env.REACT_APP_HYDRATE_DELAY;
  }
  localStorage.setItem("first_time", "1");
}

setTimeout(
  function() {
    const stores = init(window.DATA);
    ReactDOM.hydrate(
      <Provider {...stores}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>,
      document.getElementById("root"),
    );
    if (module.hot) {
      console.log("hot reloading active%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%");
      module.hot.accept();
    }
    listenForBeforeInstallPrompt();
    register();
  },
  timer,
  false,
);
